import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "../../utils/functions/getUrl";
import PostDataComplex from '../../services/PostDataComplex';
import PostData from '../../services/PostData';

const Login = ({ logged }) => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  let history = useNavigate();

  const [formData, setFormData] = useState({ 
      user: "",
      password: "",
    }
  );

  const [errorMessage, setErrorMessage] = useState('');

  function handleChange(event) {
    const { name, value, type, checked } = event.target
    setFormData(prevState => {
      return{
        ...prevState,
        // [event.target.name]: event.target.value
        [name]: type === "checkbox" ? checked : value
      }
    });
  };

  const handleLogin  = (e) => {
    console.log('handleLogin()');

    e.preventDefault();

    console.log('user data:->');
    console.log(formData);

    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);

    setErrorMessage('');
    
    if( localHost || network) {
      console.log('LOCALE!!!')

      const fakeResponse = {
        userData: {
          user: {
            "id": 1,
            "usr_name": "Romano",
            "usr_email": "",
            "token": "cb949113efcc5cdaac17b01b6ddd72c5eb1b8104809b0d034e5be62747569205"
          }
        }
      }
      
      console.log('Faked Logged in succesfully!!!');
      sessionStorage.setItem('userData', JSON.stringify(fakeResponse.userData));
      logged(true);

      console.log(`BASE_URL +"/dashboard": ${BASE_URL +"/dashboard"}`);
      history(BASE_URL +"/dashboard");

    } else {

      // PostData('POST', 'login', formData)
      PostDataComplex('users_manager', 'POST', 'login', formData)
        .then((response) => {
          console.log('response.data:->');
          console.log(response.data);

          const loginData = response.data.feedBack.loginData.checkLoginResult;

          if(loginData.user) {
            console.log('Logged in succesfully!!!');
            sessionStorage.setItem('userData', JSON.stringify(loginData));
            logged(true)

            console.log(`BASE_URL +"/dashboard": ${BASE_URL +"/dashboard"}`);
            history(BASE_URL +"/dashboard");
            
          } else {
            console.log('Login error!!!');
            console.log(loginData.error);
            setErrorMessage(loginData.error);
          }
        }
      )

    }

  }


  return (
    <Wrapper id="login--wrapper">
      {/* <Header>Login</Header> */}
      <Container id="login--container">
        <Content className="login--content">
          <ContentHeader className="login--content-header">
            PictureViewer
            <span>by rndWs.com</span>
          </ContentHeader>
          <Title className="login--title">
            Login
            <span>Not a member? <Link to={BASE_URL + "/signin"}>join PictureViewer</Link></span>
          </Title>
          <Form className="login--form">
            <Input 
              placeholder="Email or Member name " 
              id="user"
              type="text"
              value={formData.user}
              onChange={handleChange}
              name="user"
            />
            <Input 
              placeholder="Password"
              id="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              name="password"
            />
            <Button onClick={handleLogin}>Login</Button>
            <ErrorMessage>{errorMessage}</ErrorMessage>
          </Form>
          <ButtonBelly className="button-belly">
            <span><Link to={BASE_URL + "/forgot-password"}>Forgot your password?</Link></span>
          </ButtonBelly>
          
        </Content>
      </Container>
    </Wrapper>
  )
}

export default Login;

const Wrapper = styled.div `
  width: 100%;
  min-height: 100vh;
  min-height: 90vh;
  height: 90vh;
  color: #d1d1d1;
  background-color: transparent;
  font-size:2rem;
  /* padding: 10px 30px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Header = styled.div `
  /* text-align: center; */
`;

const Container = styled.div `
  /* width: 400px; */
`;
const Content = styled.div `
  border: 1px solid orange;
  padding-bottom: 2rem;
  background-color: rgba(0,0,0,0.4);
`;
const ContentHeader = styled.div `
  display: flex;
  flex-direction: column;

  text-align: center;
  background-color: #111;
  padding: 2rem 3rem;
  line-height: 1.3rem;

  span {
    font-size: 1rem;
  }
`;
const Title = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  font-size: 1.6rem;
  padding: 1rem 2.4rem;

  span {
    font-size: 1rem;

    a {
      color: #3e85f5;
    }
  }

`;

const Form = styled.form `
  display: flex;
  flex-direction: column;
  
  padding: 1rem .5rem;

`;
const Input = styled.input `
  border: 1px solid #1b1b1b;
  background-color: #0e0e0e;
  color: #d1d1d1;
  font-size: 1.1rem;
  margin-top: .2rem;
  padding: 1rem .8rem;

`;
const Button = styled.button `
  color: #fff;
  border: 1px solid #1b1b1b;
  background-color: #029F85;
  border-radius: 5px;;
  font-size: 1rem;
  padding: 1rem .8rem;
  margin-top: .4rem;

  cursor: pointer;
`;

const ErrorMessage = styled.div `
  font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;
  height: 1rem;
  color: red;
  /* border: 1px solid orange; */
  
`;

const ButtonBelly = styled.div `
  font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;
  /* border: 1px solid orange; */
  
  span {
    font-size: 1rem;
    color: #029F85;
  }
`;